(() => {
  const init = root => {
    if(root.dataset.sampleInitialized) return;
    root.dataset.sampleInitialized='true';
    const dialog=root.querySelector('[data-sample-dialog]');
    const image=dialog.querySelector('[data-sample-large]');
    const caption=dialog.querySelector('[data-sample-caption]');
    let opener;
    root.addEventListener('click',event=>{
      const button=event.target.closest('[data-sample-open]');
      if(!button) return;
      opener=button;
      image.src=button.dataset.image;
      image.alt=button.getAttribute('aria-label');
      caption.textContent=button.dataset.caption;
      dialog.showModal();
    });
    dialog.querySelector('[data-sample-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog) dialog.close();});
    dialog.addEventListener('close',()=>opener?.focus());
  };
  document.querySelectorAll('[data-ebook-samples]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ebook-samples]').forEach(init));
})();
